interface PanelProps {
	text: string;
}
const Panel = (props: PanelProps) => {
	const { text } = props;
	return <div className="panel-primary pointer">{text}</div>;
};

export default Panel;
